import React, { useState } from "react";
import styled from 'styled-components';
import Cover from '../../assets/smartCover.png'
import Logo from '../../assets/logo.webp';
import Settings from '../../assets/settings.svg'
import AppleMusic from '../../assets/apple.svg'
import Spotify from '../../assets/shiotify.svg'
import Youtube from '../../assets/YoutubeMusic.svg'
import YouCover from '../../assets/youcover.png'
import YouIcon from '../../assets/youIcon.png'
import { Modal } from './Modal/Modal'


export const SmartLinks = () => {
    const [isModalOpen, setModalOpen] = useState(false);

    const musicdata = [{
        id: 1,
        name: "Apple Music",
        icon: <AppleMusic />
    },
    {
        id: 2,
        name: "Spotify",
        icon: <Spotify />
    },
    {
        id: 3,
        name: "Youtube Music",
        icon: <Youtube />
    }
    ]

    return (
        <Container>
            <MusicBox>
                <Box>
                    <ImgBox>
                        <img src={Logo} width={70} height={19} />
                    </ImgBox>
                    <ContentBox>
                        <TextBox>
                            <div>Noah Vesper</div>
                            <span>Silver lights</span>
                        </TextBox>
                        <IconBox>
                            <Settings />
                        </IconBox>
                    </ContentBox>
                </Box>
                <MusicList>
                    {musicdata.map(({ id, name, icon }) => (
                        <Music key={id}>
                            <div style={{ display: 'flex', gap: '9px', alignItems: 'center' }}>{ }
                                {icon}
                                <span>{name}</span>
                            </div>
                            <Play>Play</Play>
                        </Music>
                    ))}
                </MusicList>
                <YouCoverBox>
                    <YouthCover>
                        <img src={YouIcon} width={32} height={23} />
                    </YouthCover>
                </YouCoverBox>

            </MusicBox>
            <TextContent>
                <Title>Add Smart Links for your releases</Title>
                <Text>Easily connect all streaming platforms — Spotify, Apple Music, YouTube, and more — in one shareable link. Make your promo smoother and reach listeners wherever they are</Text>
                <Title>
                    <div style={{ paddingTop: '10px' }}>
                        Why use Smart Links?  </div>
                </Title>
                <MainContent>
                    <RowBox>
                        <Count>01</Count>
                        <RowText><div style={{ width: '323px' }}><span>One link for everything</span> — simplify sharing across social media, websites, and promo materials</div> </RowText>
                    </RowBox>
                    <RowBox>
                        <Count>02</Count>
                        <RowText><div style={{ width: '240px' }}><span>Boost engagement </span> —  let fans choose their favorite platform instantly</div> </RowText>
                    </RowBox>
                    <RowBox>
                        <Count>03</Count>
                        <RowText><div style={{ width: '240px' }}><span>Track performance </span> — monitor clicks and conversions in one place</div> </RowText>
                    </RowBox>
                    <RowBox>
                        <Count>04</Count>
                        <RowText><div style={{ width: '260px' }}><span>Global reach</span> — Smart Links automatically adapt to the user’s region and device</div> </RowText>
                    </RowBox>
                    <CreateBox>

                        <Create onClick={() => setModalOpen(true)}>
                            Create a smart link
                        </Create>
                    </CreateBox>
                </MainContent>
            </TextContent>
            <Modal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
            />
        </Container>
    )


}
const Container = styled.div`
    display: flex;
    justify-content: space-between;
    gap:30px;
    padding: 33px 132px 32px 133px;
`;

const MusicBox = styled.div`
  background-image: url(${Cover});
  background-size: cover;
  background-position: center;
  width: 306px;
  height: 580px;
  background:#262626;
  border-radius:30px;
`;

const Box = styled.div`
  background-image: url(${Cover});
  background-size: cover;
  background-position: center;
  width: 306px;
  height: 278px;
  display:flex;
  flex-direction: column;
  align-items: center;
  position:relative;

`

const ImgBox = styled.div`
    padding-top:19px;
`

const ContentBox = styled.div`
    width: 264px;
    height: 73px;
    border-radius: 15px;
    background:#3D3D3D;
    position: absolute;
    bottom:-36px;
    padding: 13px 15px 15px 15px;
    display:flex;
    justify-content: space-between;
    align-items: center;


`

const TextBox = styled.div`
    display:flex;
    flex-direction: column;
    gap:5px;
        div{
            font-family: SF Pro Display;
            font-weight: 800;
            font-style: Heavy;
            font-size: 16px;
            leading-trim: NONE;
            line-height: 20px;
            letter-spacing: 0%;
            color:#FFFFFF;
        }
        
        span{
            font-family: SF Pro Display;
            font-weight: 300;
            font-style: Light;
            font-size: 16px;
            leading-trim: NONE;
            line-height: 20px;
            letter-spacing: 0%;
            color:#FFFFFF;

        }


`
const IconBox = styled.div`

`

const TextContent = styled.div`
    display:flex;
    flex-direction: column;
    align-items:flex-start;
    gap:15px;
    height:460px;

`

const MusicList = styled.div`
    padding: 51px 22px 15px 20px;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    gap:15px;
`

const Music = styled.div`
    width:100%;
    height:25px;
    display:flex;
    justify-content: space-between;

    span{
        font-family: SF Pro Display;
        font-weight: 300;
        font-style: Light;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 14px;
        letter-spacing: 0%;
        color: #FFFFFF;
    }
`

const Play = styled.div`
    width: 49px;
    height: 25px;
    left: 720px;
    border-radius: 8px;
    border: 1px solid #FFFFFF;
    font-family: SF Pro Display;
    font-weight: 300;
    font-style: Light;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 14px;
    letter-spacing: 0%;
    color: #FFFFFF;
    display:flex;
    justify-content:center;
    align-items: center;
    cursor:pointer;
`

const YouCoverBox = styled.div`
    padding: 0 22px 19px 20px;
   
`

const YouthCover = styled.div`
    background-image: url(${YouCover});
    background-size: cover;
    background-position: center;
    width: 264px;
    height: 112px;
    border-radius: 15px;
    display:flex;
    justify-content:center;
    align-items: center;

`
const Title = styled.div`
    font-family: Outfit;
    font-weight: 500;
    font-style: Medium;
    font-size: 30px;
    leading-trim: NONE;
    line-height: 33px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:#000000;

`

const Text = styled.div`
    font-family: SF Pro Display;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:#000000;
`

const MainContent = styled.div`
    display:flex;
    flex-direction: column; 
    gap:13px;
`

const RowBox = styled.div`
    display:flex;
    align-items: center;
    gap:18px;
`
const Count = styled.div`
    font-family: Outfit;
    font-weight: 500;
    font-style: Medium;
    font-size: 30px;
    leading-trim: NONE;
    line-height: 33px;
    letter-spacing: 0%;
    vertical-align: middle;

`

const RowText = styled.div`
    font-family: SF Pro Display;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    span{
        font-family: SF Pro Display;
        font-weight: 400;
        font-style: Regular;
        font-size: 15px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
        vertical-align: middle;
        color:#6777FF;

    }

`

const CreateBox = styled.div`
    padding-top:23px;
 


`
const Create = styled.div`
    width: 160px;
    height: 42px;
    border-radius: 10px;
    background:#6777FF;
    font-family: Outfit;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color:#FFFFFF;
    display:flex;
    align-items: center;
    justify-content:center;
    cursor:pointer;


`